import {
  INDEPENDENT_TYPE,
  CHAIN_SUBORDINATE_TYPE,
  fetchRetailerDetails,
  clearRetailerDetails,
} from 'registration/actions/fetch-retailer-details.actions';
import isEmpty from 'lodash/isEmpty';
import template from './retailer.html';

const mapStateToThis = ({ registration, contact }) => {
  const { retailer, error } = registration;
  const { defaultContactPhone } = contact.lottery;

  return {
    retailer,
    defaultContactPhone,
    error,
  };
};

const mapDispatchToThis = {
  fetchRetailerDetails,
  clearRetailerDetails,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications')
class SelfRegistrationRetailerController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.showSubmitButton = true;
    this.showCaptcha = true;
  }

  $onDestroy() {
    this.clearRetailerDetails();
    this.unsubscribe();
  }

  async submit(form) {
    form.$setSubmitted();

    if (form.$invalid) return;

    this.showSubmitButton = false;
    await this.fetchRetailerDetails(this.formModel);
    this.showSubmitButton = true;

    if (this.error) {
      this.showSubmitButton = false;
      this.$state.reload();
    }
    this.checkRetailerDetails();
  }

  checkRetailerDetails() {
    if (!isEmpty(this.retailer)) {
      const retailerType = this.retailer.retailerType.toLowerCase();
      const canSelfRegister = !!this.retailer.canSelfRegister;
      const { active } = this.retailer;
      const { hasPrimaryUser } = this.retailer;

      if (canSelfRegister === false && retailerType === CHAIN_SUBORDINATE_TYPE) {
        this.chainRegistrationDisabled();
      } else if (active === false) {
        this.errorAccountIsNotActive();
      } else if (hasPrimaryUser === true && retailerType !== INDEPENDENT_TYPE) {
        this.errorPrimaryUserIsAlreadyRegistered();
      }
    }
  }

  chainRegistrationDisabled() {
    this.clearRetailerDetails();
    this.$state.go('registration-chainRegistrationDisabled');
  }

  async errorAccountIsNotActive() {
    this.clearRetailerDetails();
    await this.Notifications.showAlert(
      this.gettextCatalog.getString('Retailer account is not active.'),
      this.gettextCatalog.getString('Retailer account is not active. Please contact the Lottery at {{ contactPhone }}.', {
        contactPhone: this.defaultContactPhone,
      })
    ).result;
    this.showSubmitButton = false;
    this.$state.reload();
  }

  async errorPrimaryUserIsAlreadyRegistered() {
    this.clearRetailerDetails();
    await this.Notifications.showAlert(
      this.gettextCatalog.getString('Primary user is already registered'),
      this.gettextCatalog.getString('Primary User for this Retailer is already registered.')
    ).result;
    this.showSubmitButton = false;
    this.$state.reload();
  }
}

export default class SelfRegistrationRetailerComponent {
  constructor() {
    this.template = template;
    this.controller = SelfRegistrationRetailerController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/retailer/retailer-component.js